import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { useMyNavigation } from "@/hooks/useMyNavigation"
import { UButton } from "@/ui-component"
import { useTranslation } from "react-i18next"
import DialogBox from "../Clinical/components/DialogBox/dialogBox"
import { updateNavigateToPatients } from "@/core/app/slices/order"
import { setIsRouteChangeBlocked } from "@/core/app/slices/navigationPopup/navigationPopupSlice"
import { useEffect, useState } from "react"
import { RootState } from "@/core/app/store"
import { safeCloseWindow } from "@/core/app/CloseTabContext"

function OrderClosePopup({ isPopupOpen }: { isPopupOpen: boolean }) {
  const navigate = useMyNavigation()
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()

  const { isRouteChangeBlocked } = useAppSelector(
    (state: RootState) => state.navigationPopup,
  )
  const [pendingCallback, setPendingCallback] = useState(null)

  useEffect(() => {
    if (!isRouteChangeBlocked && pendingCallback) {
      pendingCallback()
      setPendingCallback(null) // Clear after execution
    }
  }, [isRouteChangeBlocked, pendingCallback])

  const handleSetIsRouteChangeBlocked = (callback) => {
    dispatch(setIsRouteChangeBlocked({ isRouteChangeBlocked: false }))
    setPendingCallback(() => callback) // Defer execution
  }

  const onClickHandler = () => {
    handleSetIsRouteChangeBlocked(() => {
      dispatch(updateNavigateToPatients(false))
      safeCloseWindow()
    })
  }

  return (
    <DialogBox
      open={isPopupOpen}
      title={t("treat.lockPopUp.title")}
      content={
        <p style={{ margin: "0", fontSize: "14px" }}>
          {t("treat.lockPopUp.byCRB")}
        </p>
      }
      actions={
        <>
          <UButton
            onClickHandler={onClickHandler}
            variant={"text"}
            btnText={t("button.leaveOrderProcess")}
          />
        </>
      }
    />
  )
}

export default OrderClosePopup
